// «اختيارات التجار» — the RULES, shared by the web and the app (owner,
// 2026-11-02: «don't fork the rules»). Pure: no network, no platform API.
//
// THIS FILE IS SHARED: the app's src/lib/market/homePicksCore.js must be
// byte-identical (its homePicksCore.test.mjs checks the hash). Change both.
//
// The daily seed is the Riyadh date: everyone sees the same products all day
// (Growth OS / Clarity compare like with like) and they change the next day.
// «منوّع» first, a round-robin across every main category in the day's order;
// then one tab per main category. The phones category is its ACCESSORIES
// (owner, 2026-11-02): not the handsets (mobile_phones), not spare parts
// (phone_parts).
import { MAIN_CATEGORIES, nodeLabel } from './marketTaxonomy';

export const MIX = 'mix';
// Short names for the tabs; the taxonomy's own names are written for the category pages.
export const TAB_LABELS = {
  consumer_electronics: 'الإلكترونيات', phones_accessories: 'إكسسوارات الجوالات', computers_office_electronics: 'الكمبيوتر والمكتب',
  electronic_components: 'مكونات إلكترونية', home_appliances: 'الأجهزة المنزلية', apparel: 'الملابس', shoes_bags_accessories: 'الأحذية والحقائب',
  jewelry_watches: 'المجوهرات والساعات', beauty_personal_care: 'الجمال والعناية', health_medical: 'الصحة', home_kitchen: 'المنزل والمطبخ',
  furniture: 'الأثاث', home_decor_textiles: 'الديكور والمفروشات', garden_outdoor: 'الحديقة', toys_kids_baby: 'الألعاب والأطفال',
  sports_entertainment: 'الرياضة', automotive: 'السيارات', machinery: 'الآلات', tools_hardware: 'العدد والأدوات', construction_building: 'مواد البناء',
  packaging_printing: 'التغليف والطباعة', office_school: 'القرطاسية', commercial_restaurant: 'المطاعم والمحلات', electrical_energy: 'الكهرباء والطاقة',
  security_safety: 'الأمن والسلامة', agriculture_food: 'الزراعة والغذاء', raw_materials: 'المواد الخام', gifts_crafts: 'الهدايا', pet_supplies: 'الحيوانات الأليفة',
};
export const EXCLUDE_SUB = { phones_accessories: ['mobile_phones', 'phone_parts'] };
export const PICK_TABS = [
  { key: MIX, ar: 'منوّع', en: 'Mixed' },
  ...MAIN_CATEGORIES.map((code) => ({ key: code, category: code, ar: TAB_LABELS[code] || nodeLabel(code, 'ar'), en: nodeLabel(code, 'en') })),
];
export const PICKS_HOME = 8;      // on the home page, per tab
export const PICKS_MIN = 4;       // fewer eligible products than this: the tab is hidden
export const PICKS_POOL = 48;     // «عرض الكل»
export const PER_CAT = 32;               // candidates read per category per day
export const WINDOWS = 5;                // the day picks one of five windows of the category's list
export const SEARCHES = 8;               // category searches in flight at once
export const MIX_PER = 6;                // «منوّع»: candidates read per category
export const MIX_BATCH = 12;             // «منوّع» on the home: categories read per round

const dayFmt = new Intl.DateTimeFormat('en-CA', { timeZone: 'Asia/Riyadh' });
export const riyadhDay = (ms = Date.now()) => dayFmt.format(new Date(ms));

// A small deterministic PRNG (mulberry32) from a string seed.
export function seeded(seedText) {
  let h = 1779033703 ^ seedText.length;
  for (let i = 0; i < seedText.length; i++) { h = Math.imul(h ^ seedText.charCodeAt(i), 3432918353); h = (h << 13) | (h >>> 19); }
  let a = h >>> 0;
  return () => { a = (a + 0x6D2B79F5) | 0; let t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
}
/** The same order for the same seed: everyone, all day. */
export function seededShuffle(list, seedText) {
  const rnd = seeded(seedText); const a = [...list];
  for (let i = a.length - 1; i > 0; i--) { const j = Math.floor(rnd() * (i + 1)); [a[i], a[j]] = [a[j], a[i]]; }
  return a;
}

/**
 * «منوّع»: round-robin over the categories in `order` (the day's order) — the
 * first eight are eight different categories. `pools[code]` is that category's
 * eligible products in the day's order; a category not (yet) read is skipped.
 */
export function mixPools(pools, order, max = PICKS_POOL) {
  const cats = order.filter((k) => (pools[k] || []).length);
  const out = [];
  for (let i = 0; out.length < max; i++) {
    let any = false;
    for (const k of cats) { if (pools[k][i]) { any = true; out.push(pools[k][i]); if (out.length >= max) break; } }
    if (!any) break;
  }
  return out;
}
/** The day's order of the categories for «منوّع» — the same for everyone all day. */
export const mixOrder = (day) => seededShuffle([...MAIN_CATEGORIES].sort(), `${day}|${MIX}`);

/** Which window of a category's list the day reads (0 … WINDOWS-1). */
export const windowIndex = (code, day) => Math.floor(seeded(`${day}|${code}`)() * WINDOWS);
